import React from 'react';
import { useNavigate } from 'react-router';

const FooterComponent = () => {
  const navigate = useNavigate();
  return (
    <div className="footer-sec">
      <p>
        <b className="faq" onClick={() => navigate('/case-faqs')}>
          FAQ
        </b>{' '}
        <b>|</b> <b>Disclaimer:</b> We are not a legal service provider. We connect you to referrals and provide reports and initial
        assessments based on best practices. This does not constitute legal advice. Always consult with legal counsel regarding specifics.
      </p>
    </div>
  );
};

export default FooterComponent;
